import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Space, Select } from "antd";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { compose } from "redux";
import { useParams } from "react-router-dom";
import { loadCampaignById } from "../../../redux/actions/campaign-actions";
import {
  Input,
  InputNumber,
  Radio,
  Row,
  Col,
  Checkbox,
  DatePicker,
  Typography,
} from "antd";
import {
  closeUpdateVideoCreativeModal,
  updateVideoCreative,
} from "./../../../redux/actions/creative-actions";
import moment from "moment";
import {
  getDayStartTime,
  getDayEndTime,
  getLocalDate,
  getUTCDate
} from "../../../utils/appUtils";
import EditVideoCreativeForm from "./../../forms/edit-video-creative-form";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;
const flightStartDateOptions = ["Start when line starts", "Custom Start"];
const flightEndDateOptions = ["End when line ends", "Custom End"];
const dateFormat = "YYYY-MM-DD HH:mm:ss";
const EditVideoCreativeModal = ({
  editCreativeInfo,
  isEditVideoCreativeModalOpen,
  videoLine,
  accountId,
  devices,
  propType,
  creativeType,
  editCampaign
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectedDevices, setSelectedDevices] = useState(devices);
  const [flightStartDateType, setFlightStartDateType] = useState("Start when line starts");
  const [flightEndDateType, setFlightEndDateType] = useState("End when line ends");
  const [startDate, setStartDate] = useState(moment(getDayStartTime(), dateFormat));
  const [endDate, setEndDate] = useState(moment(getDayEndTime(), dateFormat));
  const [startAt, setStartAt] = useState(getDayStartTime().getTime());
  const [endAt, setEndAt] = useState(getDayEndTime().getTime());
  const { id } = useParams();

  useEffect(() => {
    (async () => {
      await dispatch(loadCampaignById(editCreativeInfo.videoLine.campaignId));
    })();

    if (editCreativeInfo !== undefined) {

      setFlightStartDateType(editCreativeInfo && editCreativeInfo.imageCreativeVersion && editCreativeInfo.imageCreativeVersion.startDateType);
      setFlightEndDateType(editCreativeInfo && editCreativeInfo.imageCreativeVersion && editCreativeInfo.imageCreativeVersion.endDateType);
      if (editCreativeInfo.videoLine.videoLineVersion.startAt === editCreativeInfo.videoCreativeVersion.startAt) {
        setStartAt(getLocalDate(editCreativeInfo.videoLine.videoLineVersion.startAt));
        setStartDate(moment(new Date(getLocalDate(editCreativeInfo.videoLine.videoLineVersion.startAt)), dateFormat));
      } else {
        setStartAt(getLocalDate(editCreativeInfo.videoCreativeVersion.startAt));
        setStartDate(moment(new Date(getLocalDate(editCreativeInfo.videoCreativeVersion.startAt)), dateFormat));
      }
      if (editCreativeInfo.videoLine.videoLineVersion.endAt === editCreativeInfo.videoCreativeVersion.endAt) {
        setEndAt(getLocalDate(editCreativeInfo.videoLine.videoLineVersion.endAt));
        setEndDate(moment(new Date(getLocalDate(editCreativeInfo.videoLine.videoLineVersion.endAt)), dateFormat));
      } else {
        setEndAt(getLocalDate(editCreativeInfo.videoCreativeVersion.endAt));
        setEndDate(moment(new Date(getLocalDate(editCreativeInfo.videoCreativeVersion.endAt)), dateFormat));
      }

      if (editCreativeInfo && editCreativeInfo.videoCreativeVersion && editCreativeInfo.videoLine) {
        var values = {
          name: editCreativeInfo.videoCreativeVersion.name !== null ? editCreativeInfo.videoCreativeVersion.name : "",
          clickUrl: editCreativeInfo.videoCreativeVersion.clickUrl !== null ? editCreativeInfo.videoCreativeVersion.clickUrl : "",
          weight: editCreativeInfo.videoCreativeVersion.weight,
          targetingState: editCreativeInfo.videoCreativeVersion.targetingState !== null ? editCreativeInfo.videoCreativeVersion.targetingState : "",
          retargetingPixelId: editCreativeInfo.videoCreativeVersion.retargetingPixelId !== null ? editCreativeInfo.videoCreativeVersion.retargetingPixelId : "",

          videoImpressionPixels: editCreativeInfo.videoCreativeVersion.videoImpressionPixels !== null
            ? JSON.parse(editCreativeInfo.videoCreativeVersion.videoImpressionPixels) : [],
        }
        form.setFieldsValue(values);

        const selectValuesTemp = [];
        const selectedDeviceList = JSON.parse(editCreativeInfo.videoCreativeVersion.devices);
        if (selectedDeviceList && selectedDeviceList.length > 0) {
          selectedDeviceList.filter(function (obj) {
            selectValuesTemp.push(obj);
          });
          setSelectedDevices(selectValuesTemp);
        }
      }
    }

    return () => {
      console.log("EditVideoCreativeModal Unmounting");
    };
  }, [isEditVideoCreativeModalOpen]);

  const handleSave = (values) => {
    if (!values.clickUrl) {
      values["clickUrl"] = null;
    }
    values["devices"] = JSON.stringify(selectedDevices);
    values["startDateType"] = flightStartDateType;
    values["startAt"] = getUTCDate(startAt);
    values["endDateType"] = flightEndDateType;
    values["endAt"] = getUTCDate(endAt);
    if (values["videoImpressionPixels"] && values["videoImpressionPixels"] !== null) {
      values["videoImpressionPixels"] = JSON.stringify(values["videoImpressionPixels"]);
    }
    form.resetFields();
    dispatch(updateVideoCreative(id, values));
    dispatch(closeUpdateVideoCreativeModal());
    resetFormStates();
  };

  const resetFormStates = () => {
    setFlightStartDateType("Start when line starts");
    setFlightEndDateType("End when line ends");
    setStartDate(moment(getDayStartTime(), dateFormat));
    setEndDate(moment(getDayEndTime(), dateFormat));
    setStartAt(getDayStartTime().getTime());
    setEndAt(getDayEndTime().getTime());
  };

  const [
    handleCancel,
    onStartDateChange,
    onEndDateChange,
    onChangeFlightDateType,
    onDeviceChange,
    isDeviceExists,
  ] = EditVideoCreativeForm(
    form,
    setStartDate,
    setEndDate,
    startAt,
    endAt,
    setStartAt,
    setEndAt,
    editCreativeInfo.videoLine,
    accountId,
    setFlightStartDateType,
    setFlightEndDateType,
    selectedDevices,
    setSelectedDevices,
    creativeType
  );

  return (
    <>
      {propType !== undefined &&
        <Modal
          title={`Update ${propType}`}
          visible={isEditVideoCreativeModalOpen}
          onCancel={handleCancel}
          footer={[]}
        >

          <Form form={form} layout={"vertical"} onFinish={handleSave}>
            {propType === "Name" && (
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please input creative name!",
                    whitespace: true,
                  },
                ]}
              >
                <TextArea showCount maxLength={255} placeholder="Untitled Creative" autoSize />
              </Form.Item>
            )}

            {propType === "Flight" && (
              <div className="card-cnt-sec grid-col-2">
                <Title level={3}>{"Flight Dates"}</Title>
                <Form.Item label="Start Date" name="flighStartDateType">
                  <Radio.Group
                    name={"startDate"}
                    defaultValue={"Start when line starts"}
                    value={flightStartDateType}
                    onChange={onChangeFlightDateType}
                    options={flightStartDateOptions}
                  />
                  {flightStartDateType === "Start when line starts" ? (
                    ""
                  ) : (
                    <DatePicker
                      defaultValue={startDate}
                      value={startDate}
                      showTime
                      format={dateFormat}
                      onChange={onStartDateChange}
                    />
                  )}
                </Form.Item>
                <Form.Item label="End Date" name="flighEndDateType">
                  <Radio.Group
                    name={"endDate"}
                    value={flightEndDateType}
                    defaultValue={"End when line ends"}
                    onChange={onChangeFlightDateType}
                    options={flightEndDateOptions}
                  />
                  {flightEndDateType === "End when line ends" ? (
                    ""
                  ) : (
                    <DatePicker
                      defaultValue={endDate}
                      value={endDate}
                      showTime
                      format={dateFormat}
                      onChange={onEndDateChange}
                    />
                  )}
                </Form.Item>

              </div>
            )}

            {propType === "Weight" && (
              <Form.Item
                label="Weight"
                name="weight"
                rules={[
                  {
                    required: true,
                    message: "Please input weight!",
                  },
                ]}
              >
                <InputNumber min={1} />
              </Form.Item>
            )}

            {propType === "Click URL" && (
              <Form.Item
                label="Click URL"
                name="clickUrl"
              >
                <Input />
              </Form.Item>
            )}

            {propType === "Retargeting Pixel" && (
              <Form.Item
                label="Retargeting Pixel"
                name="retargetingPixelId"
              >
                <Select defaultValue="" style={{ width: '100%' }}
                  value={editCreativeInfo.videoCreativeVersion.retargetingPixelId ?
                    editCreativeInfo.videoCreativeVersion.retargetingPixelId : ""}>
                  {editCampaign && editCampaign.assignedRetargetingPixels.map((option) => (
                    (
                      <Option value={option.retargetingPixelId} key={option.retargetingPixelId}>{option.name}</Option>
                    )
                  ))}
                </Select>
              </Form.Item>
            )}

            {propType === "Target State" && (
              <Form.Item
                label="Target State"
                name="targetingState"

              >
                <Input />
              </Form.Item>
            )}

            {propType === "Impression Pixels" && (
              <Form.Item className="creative-box" label="Impression Pixels" name="videoImpressionPixels">
                <Form.List name="videoImpressionPixels">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                        <Space
                          key={key}
                          style={{ display: "flex", marginBottom: 8 }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "source"]}
                            fieldKey={[fieldKey, "source"]}
                            rules={[{ required: true, message: "Please input source!" }]}
                          >
                            <Input placeholder="Source" style={{ width: "400px" }} />
                          </Form.Item>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Space>
                      ))}
                      <Form.Item>
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                          Add
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Form.Item>
            )}

            {propType === "Devices" && (
              <Form.Item label="Devices" name="devices">
                <Row>
                  {devices &&
                    devices.map((device) => (
                      <Col xs={12} sm={8} md={6} lg={6} xl={6}>
                        <Checkbox checked={isDeviceExists(device.name)} value={device.name} onChange={onDeviceChange}>
                          {device.name}
                        </Checkbox>
                      </Col>
                    ))}
                </Row>
              </Form.Item>
            )}
            <Form.Item className="text-right">
              <Button type="primary" htmlType="button" onClick={handleCancel}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      }
    </>
  );
};
function mapStateToProps(state) {
  return {
    isEditVideoCreativeModalOpen: state.creative.isEditVideoCreativeModalOpen,
    devices: state.line.devices,
    propType: state.creative.propType,
    editCampaign: state.campaign.editCampaign
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(EditVideoCreativeModal);
